// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toplevel_page_easycommerce-store ul.wp-submenu li.current {
    box-shadow: inset 4px 0 0 0 #ffffff !important;
    transition: box-shadow .1s linear;
}
#easycommerce-connect-box {
    padding: 0px !important;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/settings/src/settings-menu.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;IAC9C,iCAAiC;AACrC;AACA;IACI,uBAAuB;AAC3B","sourcesContent":[".toplevel_page_easycommerce-store ul.wp-submenu li.current {\n    box-shadow: inset 4px 0 0 0 #ffffff !important;\n    transition: box-shadow .1s linear;\n}\n#easycommerce-connect-box {\n    padding: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
